<script>
  import GraficoProvincia from './GraficoProvincia.svelte';
  import {
    dataProvince,
    regioneSelezionata,
  } from './stores/data-province.store.js';
  let regione = "Toscana";
  const unsubscribe = regioneSelezionata.subscribe((value) => {
    regione = value;
  });
  $: province = [
    ...new Set(
      $dataProvince
        .filter((entry) => entry.denominazione_regione == regione)
        .map((entry) => entry.denominazione_provincia)
    ),
  ];
</script>

{#each province as provincia}
  {#if provincia != 'In fase di definizione/aggiornamento' && provincia != 'Fuori Regione / Provincia Autonoma'}
    <GraficoProvincia {provincia} />
  {/if}
{/each}
